import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-environment-banner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="environment-banner" role="status">
      <div class="environment-banner__badge" aria-hidden="true">
        <i class="bi bi-exclamation-triangle-fill"></i>
        <span>HML</span>
      </div>

      <div class="environment-banner__marquee" aria-hidden="true">
        <div class="environment-banner__track">
          @for (item of trackItems; track item.id) {
            <span class="environment-banner__message">{{ item.text }}</span>
            <span class="environment-banner__separator">◆</span>
          }
        </div>
      </div>

      <p class="sr-only">{{ accessibleText }}</p>
    </div>
  `,
  styles: `
    @use '../../../styles/variables' as *;

    .environment-banner {
      display: flex;
      align-items: stretch;
      flex-shrink: 0;
      min-height: 32px;
      background: $color-warning;
      color: $color-warning-dark;
      overflow: hidden;
    }

    .environment-banner__badge {
      display: flex;
      align-items: center;
      gap: $space-2;
      flex-shrink: 0;
      padding: $space-1 $space-3;
      background: rgba($color-warning-dark, 0.12);
      border-right: 1px solid rgba($color-warning-dark, 0.2);
      font-size: $font-size-xs;
      font-weight: 800;
      letter-spacing: 0.08em;
      text-transform: uppercase;

      i {
        font-size: $font-size-sm;
      }
    }

    .environment-banner__marquee {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;
      overflow: hidden;
      mask-image: linear-gradient(
        to right,
        transparent,
        #000 6%,
        #000 94%,
        transparent
      );
    }

    .environment-banner__track {
      display: flex;
      align-items: center;
      width: max-content;
      animation: environment-banner-marquee 40s linear infinite;
    }

    .environment-banner__message {
      flex-shrink: 0;
      padding: 0 $space-4;
      font-size: $font-size-xs;
      font-weight: 700;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      white-space: nowrap;
    }

    .environment-banner__separator {
      flex-shrink: 0;
      opacity: 0.45;
      font-size: 0.55rem;
    }

    @keyframes environment-banner-marquee {
      from {
        transform: translateX(0);
      }

      to {
        transform: translateX(-50%);
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .environment-banner__marquee {
        mask-image: none;
      }

      .environment-banner__track {
        animation: none;
        padding: $space-1 $space-3;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
        gap: $space-1 $space-2;
      }

      .environment-banner__message {
        padding: 0;
        white-space: normal;
        text-align: center;

        &:nth-of-type(n + 6) {
          display: none;
        }
      }

      .environment-banner__separator {
        display: none;
      }
    }
  `,
})
export class EnvironmentBannerComponent {
  static readonly visible = !environment.production;

  readonly messages = [
    'Ambiente de Homologação',
    'Dados podem não refletir a produção',
    'Não utilize para operações reais',
    'Alterações aqui não afetam o ambiente de produção',
    'Ambiente exclusivo para testes e validações',
  ];

  readonly trackItems = [
    ...this.messages.map((text, index) => ({ id: `a-${index}`, text })),
    ...this.messages.map((text, index) => ({ id: `b-${index}`, text })),
  ];

  readonly accessibleText = this.messages.join('. ');
}
